import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownProps } from "../models";

interface Option {
  value: number;
  label: string;
}

const options: Option[] = [];
for (let i = 1; i <= 500; i++) {
  const message = `${i} PAX`;
  // From 1 to 20, keep all entries, from 20 to 50, only keep every 5th entry, from 50 onwards keep every 10th entry
  // This is to prevent the dropdown from becoming too large
  if ((i <= 20) || (i <= 50 && i % 5 === 0) || (i > 50 && i % 10 === 0)) {
    options.push({ value: i, label: message });
  }
}

const getOption = (value: number): Option | undefined => {
  return options.find(o => o.value === value);
}

const GuestlistAccessTypeSpotsDropdown = (props: DropdownProps<number>) => {
  const selectedOption = getOption(props.value);

  return <BaseReactSelectDropdown
    excludeKeys={[]}
    options={options}
    getLabel={v => v.label}
    getValue={(v) => v.value}
    value={selectedOption}
    onChange={(v) => props.onChange(v.value)}
    config={props.config}
  />;
};

export default GuestlistAccessTypeSpotsDropdown;